import React, { ReactNode } from "react";

interface SettingsSectionProps {
	title: string;
	description?: string;
	children: ReactNode;
}

/** A titled card. Every block on `/settings` is one of these. */
const SettingsSection: React.FC<SettingsSectionProps> = ({
	title,
	description,
	children,
}) => (
	<section className="bg-white border border-gray-200 rounded-lg p-6">
		<h2 className="text-lg font-semibold text-text-base">{title}</h2>
		{description && (
			<p className="mt-1 text-sm text-text-muted">{description}</p>
		)}
		<div className="mt-4">{children}</div>
	</section>
);

export default SettingsSection;
